import {
  Sheet,
  SheetContentResizable,
  SheetFooter,
  SheetHeader,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { T } from 'gt-react';
import { useLocalStorageValue } from '@react-hookz/web';
import {
  EntityDetailTabsProvider,
  EntityDetailTabsHeader,
  EntityDetailTabsContent,
  useEntityDetailTabsContext,
} from '@/components/system-entities/entity-detail-tabs';
import { SystemEntity } from '@erp/shared-types';
import { Tabs } from '@/components/ui/tabs';

interface PaymentDetailSlideinProps {
  paymentId: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

function PaymentDetailTabsWrapper() {
  const { activeTabId, setActiveTabId } = useEntityDetailTabsContext();
  return (
    <Tabs
      value={activeTabId}
      onValueChange={setActiveTabId}
      className="flex flex-col flex-1 min-h-0"
    >
      <SheetHeader className="shrink-0 grow-0">
        <EntityDetailTabsHeader />
      </SheetHeader>
      <div className="flex-1 min-h-0 overflow-hidden">
        <EntityDetailTabsContent />
      </div>
    </Tabs>
  );
}

export function PaymentDetailSlidein({
  paymentId,
  isOpen,
  onOpenChange,
}: PaymentDetailSlideinProps) {
  const { value: detailViewSize, set: setDetailViewSize } =
    useLocalStorageValue<number>('payment-detail-view-size', {
      defaultValue: 50,
    });

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContentResizable
        resizableProps={{
          defaultSize: detailViewSize,
          onResize: setDetailViewSize,
          className: 'flex flex-col',
        }}
      >
        <EntityDetailTabsProvider
          initialEntity={{
            entityType: SystemEntity.PAYMENT,
            entityId: paymentId,
          }}
        >
          <PaymentDetailTabsWrapper />
        </EntityDetailTabsProvider>
        <SheetFooter className="shrink-0 grow-0 flex items-end border-t">
          <Button
            onClick={() => {
              onOpenChange(false);
            }}
            className="w-fit"
          >
            <T>Close</T>
          </Button>
        </SheetFooter>
      </SheetContentResizable>
    </Sheet>
  );
}
